import CaretRightOutline from './CaretRightOutline'

export default CaretRightOutline
// eslint-disable-next-line import/export
export * from './CaretRightOutline'
